import { Injectable, signal } from '@angular/core';

const THEME_STORAGE_KEY = 'theme-preference';
const DARK_MODE_CLASS = 'my-app-dark';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private isDarkMode$ = signal(this.loadPreference());

  readonly isDarkMode = this.isDarkMode$.asReadonly();

  constructor() {
    this.applyTheme(this.isDarkMode$());
  }

  toggleTheme(): void {
    const newValue = !this.isDarkMode$();
    this.isDarkMode$.set(newValue);
    this.applyTheme(newValue);
    this.savePreference(newValue);
  }

  private applyTheme(isDark: boolean): void {
    const html = document.documentElement;
    if (isDark) {
      html.classList.add(DARK_MODE_CLASS);
    } else {
      html.classList.remove(DARK_MODE_CLASS);
    }
  }

  private loadPreference(): boolean {
    try {
      return localStorage.getItem(THEME_STORAGE_KEY) === 'dark';
    } catch {
      return false;
    }
  }

  private savePreference(isDark: boolean): void {
    try {
      localStorage.setItem(THEME_STORAGE_KEY, isDark ? 'dark' : 'light');
    } catch {
      // localStorage unavailable — silently ignore
    }
  }
}
